import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import Numeric from '../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import * as columnFormatters from '../../../../../../components/SelectProduct/List/column-formatters';

export const ITEMS_URL = '/stocks';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        items: action.payload.items.map((item) => {
          let stockQty = action.payload.newQty * item.qtyInSet;
          const updatedItem = {
            ...item,
            totalCost: item.cost
              ? ((item.cost * item.qtyInSet + Number.EPSILON) * 100) / 100
              : parseFloat('0'),
            qty: stockQty,
            remainedQty: item.productCount,
          };

          return updatedItem;
        }),
      };
    case 'updateQty':
      //console.log('updateQty', action.payload);
      return {
        items: state.items.map((item) => {
          let stockQty = action.payload * item.qtyInSet;
          const updatedItem = {
            ...item,
            remainedQty: item.productCount - stockQty,
            qty: stockQty,
          };

          return updatedItem;
        }),
      };

    default:
      console.log('Wrong Dispatch: ', action);
  }
}
export default function StockItems(props) {
  const { productCode, newQty, changeItems } = props;
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [state, dispatch] = useReducer(reducer, { items: [], newQty: 0 });

  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: false,
      formatter: columnFormatters.NameColumnFormatter,
    },
    {
      dataField: 'qtyInSet',
      text: 'Unit Qty',
      sort: false,
      //formatter: ProductQuantityColumnFormatter,
      classes: 'text-center',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '90px',
      },
    },
    {
      dataField: 'productPrice',
      text: 'Unit Price',
      sort: false,
      formatter: DecimalColumnFormatter,
      classes: 'text-center',
      headerClasses: 'text-center',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    {
      dataField: 'productWeight',
      text: 'Unit Weight',
      sort: false,
      classes: 'text-center',
      headerClasses: 'text-center',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '80px',
        width: '90px',
      },
    },

    {
      dataField: 'cost',
      text: 'Unit cost',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },

    {
      dataField: 'totalCost',
      text: 'Total Cost',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },

    {
      dataField: 'qty',
      text: 'Sub Stock Qty',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },
    {
      dataField: 'remainedQty',
      text: 'Remained Qty',
      sort: false,
      //formatter: ProductQuantityColumnFormatter,
      classes: 'text-center',
      style: {
        minWidth: '80px',
        width: '90px',
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .post(ITEMS_URL, productCode, { headers: { action: 'getproductitems' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('ProductItems: ', response.data.data);
            setTotalCount(response.data.data.length);
            dispatch({
              type: 'init',
              payload: { items: response.data.data, newQty },
            });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [productCode]);

  useEffect(() => {
    console.log('newQty', newQty);
    dispatch({ type: 'updateQty', payload: newQty });
  }, [newQty]);

  useEffect(() => {
    console.log('StockItems.STATE', state);
    changeItems(state.items);
  }, [state]);

  function DecimalColumnFormatter(cellContent, row) {
    return (
      <div>
        {cellContent
          ? cellContent
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
          : '0.00'}
      </div>
    );
  }

  return (
    <div>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}

      <Card id='stockItemsCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Items - ${totalCount}`}>
          <CardHeaderToolbar></CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={false}
            local
            keyField='productCode'
            data={state.items === null ? [] : state.items}
            columns={columns}
          >
            <PleaseWaitMessage entities={state.items} />
            <NoRecordsFoundMessage entities={state.items} />
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}
